import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import environment from './environment'

const analyticalCookiesEnabled = localStorage.getItem('enabledCookies') === 'analytical'
const reactPlugin = new ReactPlugin()
const appInsights = new ApplicationInsights({
  config: {
    connectionString: environment.APPLICATIONINSIGHTS_CONNECTION_STRING,
    disableCookiesUsage: !analyticalCookiesEnabled,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
  },
})
appInsights.loadAppInsights()

export default reactPlugin
